/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Create_Partner_DescriptionInputs */



/**
* | output |
* | --- |
* | "Create a partner and invite its first admin." |
*
* @param {Partner_Admin_Create_Partner_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_create_partner_description = /** @type {((inputs?: Partner_Admin_Create_Partner_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Create_Partner_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Legen Sie einen Partner an und laden Sie dessen ersten Admin ein.")
	return /** @type {LocalizedString} */ ("Create a partner and invite its first admin.")
});